var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState, } from "react";
import isEqual from "lodash/isEqual";
import { createContainer } from "unstated-next";
function useSettings(props) {
    var _this = this;
    var _a = useState(), settings = _a[0], setSettings = _a[1];
    var getActiveUrl = useCallback(function () {
        var params = [
            {
                key: "app_id",
                value: props.substitutionsManager.getAppId(),
            },
            {
                key: "platform",
                value: props.substitutionsManager.getAppPlatform(),
            },
            {
                key: "version",
                value: props.substitutionsManager.getAppVersion(),
            },
            {
                key: "app_lang",
                value: props.substitutionsManager.getLanguage(),
            },
            {
                key: "env",
                value: props.substitutionsManager.getEnvironment(props.canSwitchEnvironments),
            },
        ]
            .map(function (p) { return p.key + "=" + p.value; })
            .join("&");
        return (process.env.REACT_APP_SETTINGS_HOST || "") + "/activeURLs.php?" + params;
    }, [props]);
    var fetchSettings = useCallback(function (activeUrls) { return __awaiter(_this, void 0, void 0, function () {
        var requests, _loop_1, indx, state_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(activeUrls.length > 0)) return [3 /*break*/, 5];
                    requests = activeUrls.map(function (activeUrl) {
                        var version = props.substitutionsManager
                            .getAppVersion()
                            .replace(/\./g, "_");
                        var build = props.substitutionsManager.getAppBuild();
                        var u = props.substitutionsManager
                            .applySubsitutions(activeUrl, {
                            VERSION: version,
                            VERSION_WITH_UNDERSCORE: version,
                            BUILD: build,
                        })
                            .replace(/%@/g, version);
                        return u;
                    });
                    _loop_1 = function (indx) {
                        var activeUrl, req, settingJson, nsettings_1, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    activeUrl = requests[indx];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 4, , 5]);
                                    return [4 /*yield*/, fetch(activeUrl)];
                                case 2:
                                    req = _a.sent();
                                    return [4 /*yield*/, req.json()];
                                case 3:
                                    settingJson = _a.sent();
                                    nsettings_1 = __assign(__assign({}, props.defaultSettings), settingJson.settings.reduce(reduceSettings, {}));
                                    setSettings(function (prevState) {
                                        if (!isEqual(nsettings_1, prevState)) {
                                            return nsettings_1;
                                        }
                                        return prevState;
                                    });
                                    return [2 /*return*/, { value: void 0 }];
                                case 4:
                                    error_1 = _a.sent();
                                    return [2 /*return*/, "continue"];
                                case 5: return [2 /*return*/];
                            }
                        });
                    };
                    indx = 0;
                    _a.label = 1;
                case 1:
                    if (!(indx < requests.length)) return [3 /*break*/, 4];
                    return [5 /*yield**/, _loop_1(indx)];
                case 2:
                    state_1 = _a.sent();
                    if (typeof state_1 === "object")
                        return [2 /*return*/, state_1.value];
                    _a.label = 3;
                case 3:
                    indx++;
                    return [3 /*break*/, 1];
                case 4:
                    console.warn("Failed to get settings");
                    _a.label = 5;
                case 5: return [2 /*return*/];
            }
        });
    }); }, [props]);
    var fetchActiveUrls = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var activeUrl;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    activeUrl = getActiveUrl();
                    return [4 /*yield*/, fetch(activeUrl)
                            .then(function (r) { return r.json(); })
                            .then(function (result) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0: return [4 /*yield*/, fetchSettings(result.URLs)];
                                    case 1:
                                        _a.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); })];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [fetchSettings, getActiveUrl]);
    var hasSettings = function () {
        return settings !== undefined;
    };
    var settingsLength = function () {
        if (settings) {
            return Number(Object.keys(settings).length);
        }
        return 0;
    };
    var raw = function (key, defaultValue) {
        var defaultReturn = defaultValue || "";
        return validSettingsKey(key) ? settings[key] : defaultReturn;
    };
    var json = function (key, defaultValue, substitutions) {
        var defaultReturn = defaultValue || "";
        return validSettingsKey(key)
            ? JSON.parse(settingsKeySubs(key, substitutions))
            : defaultReturn;
    };
    var string = function (key, defaultValue, substitutions) {
        var defaultReturn = defaultValue || "";
        return validSettingsKey(key)
            ? settingsKeySubs(key, substitutions)
            : defaultReturn;
    };
    var colour = function (key, defaultValue) {
        var defaultReturn = defaultValue || "#000000";
        var value = validSettingsKey(key)
            ? "#" + String(settings[key]).replace("#", "")
            : defaultReturn;
        return value.length >= 4 && value.length <= 9 && value.startsWith("#")
            ? value
            : "#000000";
    };
    var url = function (key, defaultValue, substitutions) {
        if (substitutions === void 0) { substitutions = {}; }
        var defaultReturn = defaultValue || "";
        return validSettingsKey(key)
            ? settingsKeySubs(key, substitutions)
            : defaultReturn;
    };
    var number = function (key, defaultValue) {
        var defaultReturn = defaultValue && !isNaN(defaultValue) ? defaultValue : 0;
        var value = validSettingsKey(key)
            ? Number(settings[key])
            : defaultReturn;
        return !isNaN(value) ? value : defaultReturn;
    };
    var integer = function (key, defaultValue) {
        var defaultReturn = defaultValue && !isNaN(defaultValue)
            ? parseInt(String(defaultValue), 10)
            : 0;
        var value = validSettingsKey(key)
            ? parseInt(String(settings[key]), 10)
            : defaultReturn;
        return !isNaN(value) ? value : defaultReturn;
    };
    var float = function (key, defaultValue) {
        var defaultReturn = defaultValue && !isNaN(defaultValue) ? defaultValue : 0;
        var value = validSettingsKey(key)
            ? parseFloat(String(settings[key]))
            : defaultReturn;
        return !isNaN(value) ? value : defaultReturn;
    };
    var bool = function (key, defaultValue) {
        var defaultReturn = defaultValue || false;
        return validSettingsKey(key) ? Boolean(settings[key]) : defaultReturn;
    };
    var urlCollection = function (key, substitutions) {
        if (substitutions === void 0) { substitutions = {}; }
        var methodKey = key + "HTTPMethod";
        var urlKey = key + "URL";
        var payloadKey = key + "Payload";
        var headersKey = key + "HTTPHeaders";
        return {
            method: string(methodKey, undefined, substitutions),
            url: string(urlKey, undefined, substitutions),
            payload: string(payloadKey, undefined, substitutions),
            headers: string(headersKey, undefined, substitutions),
        };
    };
    var reduceSettings = function (acc, setting) {
        var _a;
        if (setting) {
            return __assign(__assign({}, acc), (_a = {}, _a[setting.name] = setting.value, _a));
        }
        return acc;
    };
    var validSettingsKey = function (key) {
        return settings !== undefined && settings[key] !== undefined;
    };
    var settingsKeySubs = function (key, substitutions) {
        if (substitutions === void 0) { substitutions = {}; }
        return props.substitutionsManager.applySubsitutions(String(settings[key]), substitutions);
    };
    var requestSettings = useCallback(function () { return __awaiter(_this, void 0, void 0, function () {
        var requestSettingsInterval;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestSettingsInterval = props.requestSettingsInterval;
                    return [4 /*yield*/, fetchActiveUrls()];
                case 1:
                    _a.sent();
                    setTimeout(requestSettings, requestSettingsInterval || 60000);
                    return [2 /*return*/];
            }
        });
    }); }, [fetchActiveUrls, props]);
    useEffect(function () {
        requestSettings();
    }, [requestSettings]);
    return {
        fetchActiveUrls: fetchActiveUrls,
        hasSettings: hasSettings,
        settingsLength: settingsLength,
        raw: raw,
        json: json,
        string: string,
        colour: colour,
        url: url,
        number: number,
        integer: integer,
        float: float,
        bool: bool,
        urlCollection: urlCollection,
        substitutionsManager: props === null || props === void 0 ? void 0 : props.substitutionsManager,
        canSwitchEnvironments: props === null || props === void 0 ? void 0 : props.canSwitchEnvironments
    };
}
export var SettingsContainer = createContainer(useSettings);
